// @flow
import PropTypes from "prop-types";
import ProfileCard from "./ProfileCard";

const ProfileList = ({profiles, magOnly, sampleOnly, sampleType, selectedId, onRadioChanged, showDisabled=false, isReadOnly=false}) => {

    if(!profiles || profiles.length===0) {
        return <option disabled>(no profiles available)</option>;
    }
    
    if(magOnly) {
        profiles = profiles?.filter(item => item.type===0 && (!showDisabled?item.enabled===true:true))??[];
    }
    if(sampleOnly) {
        let allSampleProfiles = profiles = profiles?.filter(item => item.type !== 0 && (!showDisabled ? item.enabled === true : true)) ?? [];
        if (sampleType === undefined) {
            profiles = allSampleProfiles;
        } else {
            // NOTE: this is left here as a placeholder for future implementation when we want to filter
            // on the TYPE of profile - slide or block.   For the moment, this does the same thing as 
            // the above case 'sampleType===undefined' -pott 230519
            profiles = profiles?.filter(item => {
                const specificSampleType = item.subType ?? item.holdsSampleType;  // APIV2 || APIV1 result
                if (!specificSampleType) { // return this one since we don't know what type it is
                    return (!showDisabled ? item.enabled === true : true)
                }
                return specificSampleType === sampleType && (!showDisabled ? item.enabled === true : true);
            }) ?? [];
        }
    }

        return (<div id="profilesList" className="">
                {profiles.map(item => <ProfileCard key={item.id} profile={item}
                                                   radioGroupName="profileRadios" checked={selectedId === item.id}
                                                   onRadioChanged={(profileId) => onRadioChanged(profileId)}
                                                   isReadOnly={isReadOnly}/>)}
            </div>);
}

ProfileList.propTypes = {
    profiles: PropTypes.array.isRequired,
    magOnly: PropTypes.bool,
    sampleOnly: PropTypes.bool,
    sampleType: PropTypes.number,
    selectedId: PropTypes.number,
    showDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool
}

export default ProfileList;